import { PhysicalAttackSkill, StatusSkill } from "../../core/skill";
import { Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";

import * as type from "../../core/type";
import * as cond from "../../core/cond";
import * as effect from "../../core/effect";
import * as state from "../../core/state";
import * as pred from "../../core/pred";

export const 战·破元归衍 = new PhysicalAttackSkill(
    "战·破元归衍",
    type.战斗,
    [
        "消除对手的回合类效果，消除成功令对手所有攻击技能PP值归零",
        "衍化自身的武道",
        "下2回合自身造成的伤害提升50%",
    ],
    90,
    [
        new Effect(new effect.消除回合(), Timing.onDamage),
        new RoundEffect(
            Timing.actionEnd,
            3,
            new effect.增伤(50),
        )
    ],
    3,
    false,
    1,
    5
)

export const 战·神罡不灭 = new StatusSkill(
    "战·神罡不灭",
    [
        "5回合内，免疫并反弹所有受到的异常状态",
        "5回合内，自身不受能力下降效果影响",
        "2回合内，自身免疫受到的攻击",
        "3回合内，每回合使用技能附加对手最大体力1/3的百分比伤害"
    ],
    [],
)

export const 战·归真复元 = new StatusSkill(
    "战·归真复元",
    [
        "复原自身的武道衍化轨迹",
        "全属性+1，自身体力高于对手时强化效果翻倍",
        "4回合内，每回合附加自身最大体力1/3的百分比伤害并恢复等量体力，当前体力低于最大体力的1/2时效果翻倍",
        "下2回合，自身所有技能先制+2",
    ],
    [
        new Effect(new effect.强化(1, cond.若当前体力高于对手), Timing.onSkillHit),
        new RoundEffect(
            Timing.onSkillHit,
            4,
            new effect.回血·固伤(pred.自身最大体力的x分之一(3), undefined, undefined, cond.若自身体力低于x分之一(2)),
        )
    ]
)

export const 战·日月逆行 = new PhysicalAttackSkill(
    "战·日月逆行",
    type.普通,
    [
        "无视对手免疫攻击效果",
        "若自身处于能力下降状态，则先制+3",
        "反转自身的能力下降状态，反转成功则100%令对手害怕",
        "将自身的武道衍化轨迹改为逆转",
        "将武道正转期间抵挡的伤害以固定伤害的形式反馈给对手，若对手为自身天敌则反馈的固定伤害翻倍",
    ],
    150,
    [],
    0,
    false,
    1,
    5
)

export const 战神·破天闪 = new PhysicalAttackSkill(
    "战神·破天闪",
    type.战斗,
    [
        "若对手处于能力强化状态则先制+2",
        "若自身不处于能力提升状态则先制+2",
        "吸取对手的能力提升状态，吸取成功则令对手2回合内无法使用属性技能",
        "若自身武道衍化轨迹为正转，则2回合内对手无法通过技能恢复体力",
        "若自身武道衍化轨迹为逆转，则2回合内对手造成的攻击伤害减少50%",
    ],
    160,
    [],
    0,
    true,
    1,
    5
)
